import Vue from 'vue';

Vue.filter('numberWithSpaces', ( number, delimiter = ".", zeroPadding = false ) => {
  if (number === null || number === undefined) return '';
  if (+number === 0) return number;
  let parts = number.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  if (zeroPadding) {
    if (!parts[1]) parts[1] = '00';
    if (parts[1].length < 2) parts[1] += '0';
  }
  return parts.join(delimiter);
});
